/* מאתר מוצרים — 4 צעדים מול נתוני הקטלוג החיים של החנות. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var panel = $('#finderPanel'), out = $('#finderOut');
  if (!panel || !window.NM) return;
  var S = NM.shop || {};

  var TYPES = [
    { label: 'שולחן עבודה', subs: ['stainless-tables'] },
    { label: 'כיור', subs: ['sinks', 'stainless-tables'], word: 'כיור' },
    { label: 'מדף', subs: ['wall-shelves', 'shelf-units'] },
    { label: 'ארון', subs: ['stainless-cabinets'] },
    { label: 'עגלה', subs: ['trolleys'] },
    { label: 'תבנית גסטרונום', subs: ['gastronorm-pans'] },
    { label: 'מקרר', subs: ['fridges', 'counter-fridges', 'freezers'] },
  ];
  var BUDGET = [
    { label: 'עד ₪500', lo: 0, hi: 500 },
    { label: '₪500–1,500', lo: 500, hi: 1500 },
    { label: '₪1,500–4,000', lo: 1500, hi: 4000 },
    { label: '₪4,000 ומעלה', lo: 4000, hi: Infinity },
    { label: 'אין העדפה', lo: 0, hi: Infinity },
  ];
  var state = { step: 1, type: null, w: null, d: null, budget: null };
  var ALL = [];

  function pool() {
    if (!state.type) return [];
    return ALL.filter(function (p) {
      if (state.type.subs.indexOf(p.s) < 0) return false;
      if (state.type.word && p.n.indexOf(state.type.word) < 0) return false;
      return true;
    });
  }
  function buckets(items, key) {
    var m = {};
    items.forEach(function (p) { var v = p[key]; if (typeof v !== 'number') return; var b = Math.round(v / 10) * 10; m[b] = (m[b] || 0) + 1; });
    return Object.keys(m).map(Number).sort(function (a, b) { return a - b; });
  }
  function setStep(n) {
    state.step = n;
    Array.prototype.forEach.call(document.querySelectorAll('.finder__step'), function (s) { s.classList.toggle('is-on', +s.getAttribute('data-step') === n); });
    render();
  }
  function opts(list, cur, mono) {
    return '<div class="finder__opts">' + list.map(function (o, i) {
      return '<button class="fopt-btn' + (mono ? ' fopt-btn--mono' : '') + (cur === i ? ' is-on' : '') + '" type="button" data-i="' + i + '">' + NM.esc(o) + '</button>';
    }).join('') + '</div>';
  }
  function nav(canBack, canNext) {
    return '<div class="finder__nav">' +
      (canBack ? '<button class="btn btn--ghost btn--sm" type="button" id="fBack">חזרה</button>' : '<span></span>') +
      (canNext ? '<button class="btn btn--sm" type="button" id="fNext">המשך</button>' : '<span></span>') + '</div>';
  }
  function bindOpts(fn) {
    Array.prototype.forEach.call(panel.querySelectorAll('.fopt-btn'), function (b) { b.addEventListener('click', function () { fn(+b.getAttribute('data-i')); }); });
  }
  function render() {
    var p = pool();
    if (state.step === 1) {
      panel.innerHTML = '<span class="tag tag--red">צעד 01</span><h2 class="h2" style="margin:10px 0 4px">מה אתם צריכים?</h2><p class="lead">בחרו את סוג המוצר.</p>' +
        opts(TYPES.map(function (t) { return t.label; }), TYPES.indexOf(state.type)) + nav(false, !!state.type);
      bindOpts(function (i) { state.type = TYPES[i]; state.w = null; state.d = null; render(); });
    } else if (state.step === 2) {
      var ws = buckets(p, 'w');
      panel.innerHTML = '<span class="tag tag--red">צעד 02</span><h2 class="h2" style="margin:10px 0 4px">רוחב</h2>' +
        '<p class="lead">' + (ws.length ? 'רוחבים שקיימים בקטלוג עבור ' + NM.esc(state.type.label) + ' (ס״מ).' : 'אין נתוני רוחב לקטגוריה הזאת — אפשר לדלג.') + '</p>' +
        (ws.length ? opts(ws.concat(['לא משנה']).map(String), state.w === null ? ws.length : ws.indexOf(state.w), true) : '') + nav(true, true);
      bindOpts(function (i) { var w = buckets(p, 'w'); state.w = i >= w.length ? null : w[i]; render(); });
    } else if (state.step === 3) {
      var p2 = p.filter(function (x) { return state.w === null || Math.round((x.w || -99) / 10) * 10 === state.w; });
      var ds = buckets(p2, 'd');
      panel.innerHTML = '<span class="tag tag--red">צעד 03</span><h2 class="h2" style="margin:10px 0 4px">עומק</h2>' +
        '<p class="lead">' + (ds.length ? 'עומקים זמינים (ס״מ).' : 'אין נתוני עומק להתאמה הזאת — אפשר לדלג.') + '</p>' +
        (ds.length ? opts(ds.concat(['לא משנה']).map(String), state.d === null ? ds.length : ds.indexOf(state.d), true) : '') + nav(true, true);
      bindOpts(function (i) { var d = buckets(p2, 'd'); state.d = i >= d.length ? null : d[i]; render(); });
    } else {
      panel.innerHTML = '<span class="tag tag--red">צעד 04</span><h2 class="h2" style="margin:10px 0 4px">תקציב</h2><p class="lead">טווח המחיר לפריט.</p>' +
        opts(BUDGET.map(function (b) { return b.label; }), BUDGET.indexOf(state.budget)) + nav(true, false);
      bindOpts(function (i) { state.budget = BUDGET[i]; render(); results(); });
      if (state.budget) results();
    }
    var back = $('#fBack'), next = $('#fNext');
    if (back) back.addEventListener('click', function () { setStep(state.step - 1); });
    if (next) next.addEventListener('click', function () { setStep(state.step + 1); });
    if (state.step !== 4) out.innerHTML = '';
  }
  function results() {
    var r = pool().filter(function (p) {
      if (state.w !== null && Math.round((p.w || -99) / 10) * 10 !== state.w) return false;
      if (state.d !== null && Math.round((p.d || -99) / 10) * 10 !== state.d) return false;
      if (state.budget && !(p.p >= state.budget.lo && p.p < state.budget.hi)) return false;
      return true;
    }).filter(function (p) { return p.i; });
    if (!r.length) {
      out.innerHTML = '<div class="empty" style="padding-block:30px"><div class="h3">אין פריט מדף בהתאמה הזאת</div>' +
        '<p>זה בדיוק המקרה שבו מייצרים לפי מידה. שלחו לנו את המידות ונחזור עם הצעה.</p>' +
        '<a class="btn btn--red" href="' + NM.esc(S.pages + 'custom') + '">שלחו לנו מידה לייצור</a></div>';
      return;
    }
    // שורות מלאות: עד 8 תוצאות, בכפולות של 4 כשיש מספיק
    var n = r.length >= 4 ? Math.min(8, Math.floor(r.length / 4) * 4) : r.length;
    out.innerHTML = '<div class="rule" style="margin-bottom:22px"></div>' +
      '<div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:16px">' +
      '<h3 class="h3">' + r.length + ' התאמות</h3><a class="ulink" href="' + NM.esc(S.collectionsUrl) + '">לקטלוג המלא</a></div>' +
      '<div class="pgrid pgrid--4">' + r.slice(0, n).map(NM.cardHTML).join('') + '</div>';
  }
  NM.loadIndex().then(function (d) { ALL = d.products; render(); });
})();
